<template>
  <div>
    <vue-title :title="$t('applications.title')" />
    <v-alert :value="!this.$store.getters['user'].profileCompleted" type="error" transition="scale-transition" >
        {{ $t("applications.profileNotFilled") }}
    </v-alert>
    <v-btn to="applications/new" color="success" :disabled="!this.$store.getters['user'].profileCompleted">
      {{ $t("ctrl.add") }}
    </v-btn>

    <v-tooltip bottom v-if="$store.getters['isAdministrator']">
      <template v-slot:activator="{ on }" >
        <div v-on="on" style="width:0; display:inline;">
        <v-btn class="mx-2" icon v-on:click="$refs.dlgAssignCategories.show()">
          <v-icon color="success">category</v-icon>
        </v-btn>
        </div>
      </template>
      <span>{{ $t("applications.assignCategories") }}</span>
    </v-tooltip>

    <v-tooltip bottom v-if="$store.getters['isAdministrator']">
      <template v-slot:activator="{ on }" >
        <div v-on="on" style="width:0; display:inline;">
        <v-btn class="mx-2" icon v-on:click="$refs.dlgClearCategories.show()" >
          <v-icon color="error">category</v-icon>
        </v-btn>
        </div>
      </template>
      <span>{{ $t("applications.clearCategories") }}</span>
    </v-tooltip>

    
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn class="mx-2" icon v-on="on" >
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-select
                :items="categories" outlined
                :label="this.$t('application.category')"
                v-model="filterCategory"
                prepend-icon="category">
              </v-select>
            </v-row>
            <v-row>
              <v-select style="display:inline-flex;" 
                :items="types" outlined 
                :label="this.$t('application.type')"
                v-model="filterType"
                prepend-icon="group">
              </v-select>
            </v-row>
            <v-row>
              <v-select style="display:inline-flex;" 
                :items="statuses" outlined 
                :label="this.$t('ctrl.status')"
                v-model="filterStatus"
                prepend-icon="assignment_turned_in">
              </v-select>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-text-field
          v-model="search"
          prepend-icon="search"
          :label="$t('ctrl.search')"
          single-line
          hide-details
      ></v-text-field>
    <v-data-table :items="filteredItems" :headers="headers" :search="search"
      must-sort hide-default-footer disable-pagination>
      <template v-slot:item.title="{item}">
        <router-link :to="'applications/'+item.id">{{ item.title }}</router-link>
      </template>
      <template v-slot:item.assignedCategory.label="{item}">
        {{ item.assignedCategory ? item.assignedCategory.name : $t('application.unassigned') }}
      </template>
      <template v-slot:item.applicationType="{item}">
        {{ applicationType(item.applicationType) }}
      </template>
      <template v-slot:item.payment.reference="{item}">
        <v-icon v-if="item.paymentConfirmed" color="green">attach_money</v-icon><span v-else>{{ (item.payment.reference) }}</span>
      </template>
      <template v-slot:item.status="{item}">
        <FCCApplicationStatus :status="item.status" />
      </template>
    </v-data-table>
    <ConfirmDialog 
      ref="dlgAssignCategories"
      :onConfirm="assignCategories"
      message="applications.assignCategoriesConfirmation"
      confirm="ctrl.confirm"
      cancel="ctrl.cancel" />
    <ConfirmDialog 
      ref="dlgClearCategories"
      :onConfirm="clearCategories"
      message="applications.clearCategoriesConfirmation"
      confirm="ctrl.confirm"
      cancel="ctrl.cancel" />
  </div>
</template>

<script>
  import {
    VTextField,
    VDataTable,
    VTooltip,
    VAlert,
    VSelect
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'
  import FCCApplicationStatus from '../components/FCCApplicationStatus'
  import ConfirmDialog from '../dialogs/ConfirmDialog.vue'

  export default {
    name: 'Applications',
    data: () => ({
      search: "",
      items: [],
      filterCategory: "/",
      filterType: "/",
      filterStatus: "/",
      dialog: false
    }),
    computed: {
      headers: function () {
        var h = [
          { text: this.$t('application.title'), value: 'title' },
          { text: this.$t('application.type'), value: 'applicationType' },
          { text: this.$t('application.category'), value: 'assignedCategory.label' }
        ];
        if (this.$store.getters['isAdministrator'])
        {
          h.push({ text: this.$t('application.reference'), value: 'payment.reference' });
        }
        h.push({ text: this.$t('ctrl.status'), value: 'status' });
        return h;
      },
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      selectedCompetition: function() {
        return this.$store.getters['competitionId'];
      },
      categories: function(){
        var c = this.items.map(i => i.assignedCategory != null && i.assignedCategory.name)
        c.unshift("/");
        return c;
      },
      types: function(){
        var c = this.items.map(i => this.$t('application.'+Array('individual', 'tandem', 'relay')[i.applicationType]))
        c.unshift("/");
        return c;
      },
      statuses: function(){
        var c = this.items.map(i => i.status)
        c.unshift("/");
        return c;
      },
      filteredItems: function(){
        var fil = this.filterCategory;
        var typ = this.filterType;
        var tos = this.applicationType;
        var sts = this.filterStatus;
        return this.items
          .filter(i => fil == '/' || (i.assignedCategory != null && i.assignedCategory.name == fil))
          .filter(i => typ == '/' || tos(i.applicationType) == typ)
          .filter(i => sts == '/' || i.status == sts);
      } 
    },
    methods: {
      applicationType: function(i) {
        return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
      },
      reload: function(){
        fccapi.competitionGet('applications').then((r) => {
          this.items = r.data;
        })
      },
      assignCategories: function(){
        fccapi.post(`competitions/${this.$store.getters['competitionId']}/assign-categories`, {}).then(d => {
          console.log(d);
          this.reload();
        }).catch(e => {
          console.log(e)
        })
      },
      clearCategories: function(){
        fccapi.post(`competitions/${this.$store.getters['competitionId']}/clear-categories`, {}).then(d => {
          console.log(d);
          this.reload();
        }).catch(e => {
          console.log(e)
        })
      }
    },
    props: {
      source: String
    },
    components: {
      VDataTable,
      VTextField,
      VTooltip,
      FCCApplicationStatus,
      VAlert,
      VSelect,
      ConfirmDialog
    },
    mounted() {
      this.reload();
    },
    watch: {
      selectedCompetition() {
        this.reload();
      }
    }
  }
</script>